<template>
  <div class="w-full stepper-container relative">
    <div class="stepper">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="step"
        :class="{ active: index <= current }"
      >
        <div class="step-inner">
          <div
            class="
              step-circle
              h-10
              w-10
              sm:h-14 sm:w-14
              rounded-full
              text-xl
              mb-1
            "
            :class="{
              'border-brand border-4 text-black bg-white': index <= current,
              'border-2 custom-grey bg-white text-grey': index > current,
              'bg-brand text-white': index < current,
            }"
          >
            <span v-if="index < current">
              <i class="fa fa-check"></i>
            </span>
            <span
              v-else
              :class="{
                'text-1xl': $mq != 'mobile',
                'font-semibold text-lg': $mq == 'mobile',
              }"
            >
              {{ index }}
            </span>
          </div>
          <div class="step-text text-md hidden sm:block sm:text-sm font-medium">
            {{ step.short_name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["current", "steps"],
};
</script>

<style lang="scss" scoped>
// Stepper
$stepper-complete: #aeaeae;
$stepper-incomplete: #d8d8d8;
$stepper-bg: rgba(#fff, 0.25);

.stepper-container {
  background-color: $stepper-bg;
  padding: 1rem;
  border-radius: 5em;
}
.custom-grey {
  border-color: #d8d8d8;
}
.stepper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.step {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  width: 100%;
  &:after {
    content: "";
    display: block;
    width: 100%;
    position: relative;
    height: 2px;
    top: -5px;
    background-color: $stepper-incomplete;
  }
  &:before {
    content: "";
    display: block;
    width: 100%;
    position: relative;
    height: 2px;
    top: -5px;
    background-color: $stepper-incomplete;
  }
  &:last-child {
    flex-basis: 70%;
    &:after {
      display: none;
    }
  }
  &:first-child {
    flex-basis: 70%;
    &:before {
      display: none;
    }
  }
}
.step.active {
  color: white;
  &:after,
  &:before {
    background-color: $stepper-incomplete;
  }
  + .step:not(.active) {
    &:before {
      background-color: $stepper-incomplete;
    }
  }
}
.step-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.step-circle {
  display: flex;
  justify-content: center;
  align-items: center;
}
.step-text {
  color: #333;
  position: absolute;
  bottom: -5px;
}

@media (max-width: 425px) {
  .step {
    &.active:after,
    &.active:before {
      background: #b8becc !important;
    }
    &:after {
      height: 7px !important;
      background: #b8becc !important;
      margin-right: 8% !important;
      margin-left: 8% !important;
    }
    &:before {
      height: 7px !important;
      background: #b8becc !important;
      margin-right: 8% !important;
      margin-left: 8% !important;
    }
  }
  .step-circle {
    &.custom-grey {
      border-color: #b8becc !important;
    }
  }
}
</style>
